import { TabItem } from '../tabs.types';
import { TabPill } from './TabPill';
import { TabsScrollArea } from './TabsScrollArea';

interface ScrollableTabsProps {
  items: TabItem[];
  selectedId: string;
  onSelect: (id: string) => void;
}

export function ScrollableTabs({ items, selectedId, onSelect }: ScrollableTabsProps) {
  return (
    <TabsScrollArea>
      {items.map((item) => (
        <TabPill
          key={item.id}
          label={item.label}
          secondaryLabel={item.secondaryLabel}
          isActive={item.id === selectedId}
          endIcon={item.endIcon}
          tooltip={item.tooltip}
          onClick={() => onSelect(item.id)}
          testId={item.testId}
        />
      ))}
    </TabsScrollArea>
  );
}
